module.exports = __webpack_public_path__ + "img/solution-image.2ebbdcdd.png";